import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CTASection = () => {
  return (
    <section className="relative bg-navy overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #D4AF37 1px, transparent 0)", backgroundSize: "32px 32px" }} />
      <div className="relative max-w-5xl mx-auto px-5 py-24 text-center">
        <p className="text-xs sm:text-sm tracking-[0.25em] uppercase font-bold text-gold mb-5">Start Building</p>
        <h2 className="font-display text-4xl sm:text-5xl text-white leading-tight">
          Let's turn your vision into <span className="text-gold-gradient">reality.</span>
        </h2>
        <p className="mt-6 text-white/70 max-w-xl mx-auto">
          Request a free, no-obligation quote and let our team deliver your project with precision, on time and within budget.
        </p>
        <Link
          to="/contact"
          data-testid="cta-quote-btn"
          className="inline-flex items-center gap-2 mt-9 bg-gold text-navy px-8 py-4 font-bold tracking-wide hover:bg-gold-light transition-colors group"
        >
          Request a Quote <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </section>
  );
};
